import { createI18n } from 'vue-i18n'
import cscz from './locales/cscz.json'
import dede from './locales/dede.json'
import enen from './locales/enen.json'
import eses from './locales/eses.json'
import frfr from './locales/frfr.json'
import itit from './locales/itit.json'
import nlnl from './locales/nlnl.json'
import plpl from './locales/plpl.json'
import sksk from './locales/sksk.json'
import int  from './locales/enen.json'
import router from '../router'
import axios from 'axios'

export const defaultLocale = 'int'

export const languages = {
    cscz: cscz,
    dede: dede,
    enen: enen,
    eses: eses,
    frfr: frfr,
    itit: itit,
    nlnl: nlnl,
    plpl: plpl,
    sksk: sksk,
    int: int,
}

var currentLocale = 'int';

if(getCookie('portal_lang') != "") {
    currentLocale = getCookie('portal_lang');
} else {
    console.log((navigator.language).toLowerCase() || (navigator.userLanguage).toLowerCase());
    switch((navigator.language).toLowerCase() || (navigator.userLanguage).toLowerCase()) {
        case 'de':      //German (Standard)
        case 'de-at':   //German (Austria)
        case 'de-de':   //German (Germany)
        case 'de-li':   //German (Lichtenstein)
        case 'de-lu':   //German (Luxembourg)
        case 'de-ch':   //German (Switzerland)
            currentLocale = 'dede';
            break;
        case 'en-gb':   //English (United Kingdom)
            currentLocale = 'enen';
            break;
        case 'fr':      //French (Standard)
        case 'fr-be':   //French (Belgium)
        case 'fr-ca':   //French (Canada)
        case 'fr-fr':   //French (France)
        case 'fr-lu':   //French (Luxembourg)
        case 'fr-mc':   //French (Monaco)
        case 'fr-ch':   //French (Switzerland)
            currentLocale = 'frfr';
            break;
        case 'cs':      //Czech
            currentLocale = 'cscz';
            break;
        case 'es':      //Spanish"
        case 'es-ar':   //Spanish (Argentina)
        case 'es-bo':   //Spanish (Bolivia)
        case 'es-cl':   //Spanish (Chile)
        case 'es-co':   //Spanish (Colombia)
        case 'es-cr':   //Spanish (Costa Rica)
        case 'es-do':   //Spanish (Dominican Republic)
        case 'es-ec':   //Spanish (Ecuador)
        case 'es-sv':   //Spanish (El Salvador)
        case 'es-gt':   //Spanish (Guatemala)
        case 'es-hn':   //Spanish (Honduras)
        case 'es-mx':   //Spanish (Mexico)
        case 'es-ni':   //Spanish (Nicaragua)
        case 'es-pa':   //Spanish (Panama)
        case 'es-py':   //Spanish (Paraguay)
        case 'es-pe':   //Spanish (Peru)
        case 'es-pr':   //Spanish (Puerto Rico)
        case 'es-es':   //Spanish (Spain)
        case 'es-uy':   //Spanish (Uruguay)
        case 'es-ve':   //Spanish (Venezuela)
            currentLocale = 'eses';
            break;
        case 'nl':      //Dutch (Standard)
        case 'nl-nl':      //Dutch (Standard)
        case 'nl-be':   //Dutch (Belgian)
            currentLocale = 'nlnl';
            break;
        case 'it':      //Italian (Standard)
        case 'it-ch':   //Italian (Switzerland)
            currentLocale = 'itit';
            break;
        case 'hu':      //Hungarian
            currentLocale = 'huhu';
            break;
        case 'en-us':   //English (United States)
            currentLocale = 'enen';
            break;
        case 'pl':      //Polish
            currentLocale = 'plpl';
            break;
        case 'ca':      //Catalan
            currentLocale = 'eses';
            break;
        case 'sk':      //Slovak
            currentLocale = 'sksk';
            break;
        default:
            currentLocale = 'enen';
            break;
    }
}

let available_langs = [
'cscz',
'dede',
'enen',
'eses',
'frfr',
'itit',
'nlnl',
'plpl',
'sksk',
'int',
];


if(!available_langs.includes(currentLocale)) {
    currentLocale = 'enen';
}

const messages = Object.assign(languages);
const i18n = createI18n({
    locale: currentLocale,
    fallbackLocale: defaultLocale,
    allowCompositoin: true, // you need to specify that!
  messages
});

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
        c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
        }
    }
    return "";
}

router.beforeEach((to, from, next)=>{
    axios({
        method: 'post',
        crossDomain: true,
        withCredentials: true,
        url: 'https://configurator.loxone.com/api/loadTdcFunctions/' + currentLocale,
    })
    .then(resp => {
        messages[currentLocale].tdc = resp.data;
        messages[currentLocale].config = resp.data;
        console.log(messages);
        next();
    });
  })

export default i18n;